import { connect } from 'react-redux';
import {
  getAccessories, getAddedProducts, getInputDataToSend, getTreeStructureSettings,
} from '../../../../../store/form/selectors';
import { fetchProductsBySection, setInputDataToSend, setTreeStructureSettings } from '../../../../../store/form/actions';
import GenericAccessories from './GenericAccessories';
import { setOpenModal } from '../../../../../store/modals/actions';

const mapStateToProps = (state) => ({
  accessories: getAccessories(state),
  inputData: getInputDataToSend(state),
  addedProducts: getAddedProducts(state),
  treeStructureSettings: getTreeStructureSettings(state),
});

const mapDispatchToProps = (dispatch) => ({
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },

  setOpenModal: (modal, isOpen) => dispatch(setOpenModal(modal, isOpen)),
  setTreeStructureSettings: (
    level, parentId, parentName,
  ) => dispatch(
    setTreeStructureSettings(level, parentId, parentName),
  ),
  fetchProductsBySection: (
    fetchSettings,
  ) => {
    dispatch(fetchProductsBySection(
      fetchSettings,
    ));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GenericAccessories);
